import { z } from 'zod';

// Row contract for public.ai_usage_log (defined in migration 0001, RLS in
// 0002). Append-only cost ledger: one row per AI API call - embeddings now,
// Haiku / Sonnet calls in later PRs.
//
// studio_id / game_id / feedback_id / enrichment_id are nullable
// (ON DELETE SET NULL) so a cost record outlives the rows it references.
// cost_usd is nullable for calls whose cost is not yet known.

export const AiUsageLogStatusSchema = z.enum(['success', 'error', 'timeout']);
export type AiUsageLogStatus = z.infer<typeof AiUsageLogStatusSchema>;

export const AiUsageLogRowSchema = z.object({
  id: z.string().uuid(),
  studio_id: z.string().uuid().nullable(),
  game_id: z.string().uuid().nullable(),
  feedback_id: z.string().uuid().nullable(),
  enrichment_id: z.string().uuid().nullable(),
  provider: z.string(),
  model_name: z.string(),
  input_tokens: z.number().int().nonnegative(),
  output_tokens: z.number().int().nonnegative(),
  cost_usd: z.number().nonnegative().nullable(),
  latency_ms: z.number().int().nonnegative().nullable(),
  status: AiUsageLogStatusSchema,
  error_message: z.string().nullable(),
  created_at: z.string().datetime({ offset: true }),
});
export type AiUsageLogRow = z.infer<typeof AiUsageLogRowSchema>;
